// Thai numbers are typed the local way, with the leading 0: a mobile is 10 digits, a landline 9
// (02-123-4567, 053-123-456). Stored numbers drop that 0 (+66812345678), so the national
// number checked here is one digit shorter. Kept free of "@/" imports so Node tests can load it.

const LOCAL_LENGTHS = { mobile: [10], home: [9, 10] };
const MAX_LOCAL = 10;

/** Drops whatever was typed past the 10th digit (the 9th when typed without the 0). */
export function clampThaiDigits(digits) {
  return digits.slice(0, digits.startsWith("0") ? MAX_LOCAL : MAX_LOCAL - 1);
}

/** @param {string} national digits without the leading 0 @param {"mobile"|"home"} kind */
export function thaiLengthOk(national, kind) {
  return LOCAL_LENGTHS[kind].includes(national.length + 1);
}
